export default __webpack_public_path__ + "static/media/doc-stethoscope.29470d86.svg";